import { ResponseError } from '../../../config/api';
import { useSWR, responseInterface } from '../../../config/overrides/swr';
import useMeetingLinkPath from '../../use-meeting-link-path';
import useBypassToken from '../../use-bypass-token';
import API, { PUBLIC, PublicMeetingDetailsResponseType } from '../../../lib/api';
import { ERROR_MESSAGE } from '../../../lib/constants';
import { checkKeyArgs } from './use-meeting-public-details';

const { fetchPublicMeetingLinkDetails } = API[PUBLIC];

export default function usePublicMeetingLink(): responseInterface<PublicMeetingDetailsResponseType, ResponseError> {
  const meetingLinkPath = useMeetingLinkPath();
  const token = useBypassToken();
  const composeKey = () => checkKeyArgs(meetingLinkPath, token);
  const result = useSWR(composeKey, fetchPublicMeetingLinkDetails);

  if (!result.isValidating && !result.data && result.error) {
    return {
      ...result,
      error: {
        ...result.error,
        message: result.error.message || ERROR_MESSAGE
      }
    };
  }

  return result;
}
